import HistoryRowItem from './HistoryItem';

export default HistoryRowItem;
